import React from 'react'
import { Button, Spin, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { ModalWarningIcon } from 'src/assets/icons'
import { LoadingOutlined } from '@ant-design/icons'

import './index.scss'
import RichTextField from 'src/app/shared/components/common/rich-text-field'

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  clientName: string
  isLoading?: boolean
}

function ArchiveClientModal(props: Props) {
  const { isOpen, onClose, onConfirm, clientName = '', isLoading = false } = props
  const { t } = useTranslation()

  return (
    <ActionConfirmationModal
      icon={<ModalWarningIcon />}
      title={<Typography className='modal-title'>{t('ClientSetup:addNewClient.modal.hasExceptionsToResolve.title')}</Typography>}
      onClose={onClose}
      isOpen={isOpen}
      descriptionType='string'
      description={
        <Typography className='modal-description'>
          <RichTextField richText={t('ClientSetup:addNewClient.modal.archiveClient.description', { clientName })} />
        </Typography>
      }
      footer={[
        <Button size='middle' onClick={onClose}>
          {t('common:no')}
        </Button>,
        <Button size='middle' type='primary' onClick={onConfirm}>
          {isLoading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    color: 'white',
                  }}
                />
              }
            />
          ) : (
            t('common:yes')
          )}
        </Button>,
      ]}
    />
  )
}

export default ArchiveClientModal
